<template>
	<div>
		<el-card>
			<el-form :model="form" ref="form" label-position="left" >
				<el-form-item label="查看日期:">
                    <el-radio-group v-model="form.checkfind">
                        <el-radio-button label="year"></el-radio-button>
                        <el-radio-button label="monty"></el-radio-button>
                        <el-radio-button label="day"></el-radio-button>
                    </el-radio-group>
				</el-form-item>
				
				<el-form-item >
					<div style="display: flex;">
					<el-button type="primary" @click="submitForm()">查询</el-button>
					<el-button @click="resetForm()">重置</el-button>
					<!-- <download-excel style="margin-left: 13px;" class="export-excel-wrapper" :data="exceldata" :fields="json_fields"
						:header="title" type="xls" name="提现统计导出.xls">
						<el-button type="success">导出全部</el-button>
					</download-excel> -->
					<download-excel style="margin-left: 13px;" class="export-excel-wrapper" :data="tableData" :fields="json_fields"
						:header="title" type="xls" name="提现统计导出.xls">
						<el-button type="success">导出当前页</el-button>
					</download-excel>
					<!-- <download-excel style="margin-left: 13px;" class="export-excel-wrapper" :data="json_fields_user_tableData" :fields="json_fields_user"
						header="手机号" type="xls" name="用户手机号导出.xls">
						<el-button type="success">导出用户手机号</el-button>
					</download-excel> -->
					</div>
				</el-form-item>
			</el-form>
			
		</el-card>
		<el-card>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="day" label="时间" width="180">
				</el-table-column>
				<el-table-column prop="total_sales" label="总收入流水" width="180">
				</el-table-column>
				<el-table-column prop="expend" label="总支出流水" width="180">
				</el-table-column>
                <el-table-column prop="profit" label="毛利" width="180">
				</el-table-column>
				
				<!-- 
				<el-table-column prop="mobile" label="操作" width="180">
					<template slot-scope="scope">
						<el-button size="mini" @click="handinfo(scope.row)">流水详情</el-button>
					</template>
				</el-table-column> -->
			</el-table>
			<Pageing :page="page" :size="size" :total="total" @current-change="handleChangePage"></Pageing>
		</el-card>
	</div>
</template>

<script>
	import DownloadExcel from 'vue-json-excel'
	import Pageing from '../../components/page/page.vue'
	import {
        getericaall,
		getrechargeuserList,
		getrechargeallList,
		getallusertel
	} from '../../api/board.js'
	export default {
		components: {
			Pageing,
			DownloadExcel
		},
		data() {
			return {
				title: '提现统计导出',
				json_fields: {
					"时间": 'day',
					"总收入流水":"total_sales",
					"总支出流水":"expend",
					"毛利":"profit",
				},
				json_fields_user: {
					"手机号": 'tel',
					
				},
				json_fields_user_tableData: [],
				exceldata:[],
				formLabelWidth: '120px',
				dialogFormVisible: false,
				page: 1,
				size: 10,
				total: 0,
				tableData: [],
				runmoney: 0,
				checkAll: false,
				form: {
					tel: '',
					name: '',
					time: '',
                    checkfind: 'year',
				},
				forminfo: {},
				userinfo: {},
				userpage: 1,
				usersize: 10,
				usertotal: 0,
				userid: 807,
			};
		},
		mounted() {
			this.getuserlist()
			//this.getalltel()
			//this.DetailsForm()
		},
		methods: {
			DetailsForm() {
				getrechargeallList().then(res => {
					this.exceldata = res
					//console.log(res);
					//return res.list.data;
				})
		},
		getalltel() {
			getallusertel().then(res => {
					this.json_fields_user_tableData = res
				})
		},
		resetForm() {
			this.form.tel = '';
			this.form.name = '';
			this.form.time = '';
			this.getuserlist()
		},
		getuserlist() {
			getericaall({
				page: this.page,
				where: this.form
			}).then(res => {
				this.tableData = res.data
				this.total = res.total
			})

		},
		getmyself() {
			getrechargeuserList({
				page: this.userpage,
				uid: this.userid
			}).then(res => {
				//console.log(res);
				this.userinfo = res.data
				this.usertotal = res.total
			})
		},
		handinfo(e) {
			//console.log(e);
			this.dialogFormVisible = true
			//获取个人信息
			this.forminfo = e
			this.userid = e.uid
			this.getmyself()
		},
		submitForm() {
			this.getuserlist()
		},
		handleChangePage(val) {
			this.page = val
			this.getuserlist()
		},
		handleChangePageuserinfo(val) {
			this.userpage = val
			this.getmyself()
		}
	}
	};
</script>

<style lang="less" scoped>
	.runmoney {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
</style>
